(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-info-banner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-info-banner.js');

'use strict';

svs.lotto.components.play.views.AndraChansenInfoBanner = Marionette.View.extend({
  modelEvents: {
    'change:hasJoker': 'updateVisibility',
    'change:selectedDays': 'updateVisibility'
  },
  template() {
    return svs.numbergames.andra_chansen.banners.infoBanner({
      dateSmartness: true,
      className: 'margin-top-2'
    });
  },
  initialize() {
    this.firstPlayableDraw = svs.numbergames.draws.drawsApi.firstPlayableDraw(this.model.get('productId'));
  },
  onRender() {
    this.updateVisibility();
  },
  updateVisibility() {
    var _this$firstPlayableDr;
    let productItsId;
    if (this.model.get('selectedDays').length === 1) {
      productItsId = this.model.get('selectedDays')[0];
    } else {
      productItsId = svs.numbergames.game.draw.upcomingDrawProduct;
    }
    const {
      drawNumber,
      productId
    } = (_this$firstPlayableDr = this.firstPlayableDraw[productItsId]) !== null && _this$firstPlayableDr !== void 0 ? _this$firstPlayableDr : {};
    const isNewRules = svs.numbergames.rules.utils.lotto.isNewRules({
      drawNumber,
      product: productId
    });
    if (this.model.get('hasJoker') && !isNewRules) {
      this.el.style.display = '';
    } else {
      this.el.style.display = 'none';
    }
  }
});

 })(window);